<script>
    import {
        Icon,
        Table,
    } from 'sveltestrap';
    import {colors, calculate, convertSectoDay} from './slo.js'
    import {afterUpdate, onMount} from "svelte";

    export let slo;
    export let windows;

    const error_rates = [
        0.01,
        0.05,
        0.1,
        0.5,
        1.00,
        3.00,
        5.00,
        10.00,
        33.00,
        50.00,
        100.00,
    ]

    let data = calculate($slo, $windows, error_rates)
    // console.log(data)
    afterUpdate(() => {
        data = calculate($slo, $windows, error_rates)
    })
</script>

<Table striped size="sm">
    <thead>
    <tr>
        <th class="text-center">&nbsp;</th>
        <th class="text-center">Error rate</th>
        <th class="text-center">Alert fires after</th>
        <th class="text-center">Cost of silent period</th>
        <th class="text-center">Alert type</th>
    </tr>
    </thead>
    <tbody>
    {#each data as row}
        <tr>
            <td class="text-center align-middle">
                <Icon style="color: {colors[row['window_idx']]}" name="circle-fill"/>
            </td>
            <th scope="row" class="text-center">{
                Number(row['error_rate']).toLocaleString("en", {
                    notation: "compact",
                    compactDisplay: "short",
                })
            }%
            </th>
            <td class="text-center">{convertSectoDay(row['fire_after'])}</td>
            <td class="text-center">{Number(row['cost'])}% of monthly error budget</td>
            <td class="text-center">{row['alert']}</td>
        </tr>
    {/each}
    {#if data.length === 0}
        <tr>
            <td colspan="5" class="text-center align-middle">It looks like the current rules never fire an alert.</td>
        </tr>
    {/if}
    </tbody>
</Table>